// Decoración de Halloween (pedido del dueño, 2026-10-04: "decoración full y
// muy buena, en toooda la web"). Todo son ilustraciones SVG propias -- no
// emojis -- para que se vea igual en todos los celulares y con un solo
// estilo: noche morada, naranja calabaza, verde limo de acento.
//
// - Se muestra solo del 1 de octubre al 2 de noviembre y desaparece sola.
// - Nada de esto recibe clics (pointer-events-none) ni lo leen los lectores
//   de pantalla (aria-hidden), así que no estorba para comprar.
// - Con "reducir movimiento" activado en el teléfono, todo se queda quieto.
// - No usa el rojo de marca (DESIGN.md: el rojo es solo para acciones).
import { useEffect, useRef } from "react";

export function esTemporadaHalloween(fecha = new Date()) {
  const mes = fecha.getMonth(); // 9 = octubre, 10 = noviembre
  return mes === 9 || (mes === 10 && fecha.getDate() <= 2);
}

const C = {
  noche: "#140a24",
  noche2: "#2a1146",
  sombra: "#1c1225",
  naranja: "#f97316",
  naranjaOsc: "#c2410c",
  naranjaClaro: "#fdba74",
  luz: "#fde047",
  limo: "#84cc16",
  morado: "#a855f7",
  luna: "#fef3c7",
};

/* ------------------------------------------------------------------ */
/* Ilustraciones                                                       */
/* ------------------------------------------------------------------ */

export function Calabaza({ className = "", cara = true, brillo = true }) {
  return (
    <svg viewBox="0 0 64 58" className={className}>
      <path d="M31 12 Q30 4 36 1 L38 4 Q34 6 35 12 Z" fill="#4d7c0f" />
      <path d="M36 5 Q44 2 47 8 Q41 7 37 9" fill={C.limo} />
      <ellipse cx="19" cy="34" rx="15" ry="20" fill={C.naranjaOsc} />
      <ellipse cx="45" cy="34" rx="15" ry="20" fill={C.naranjaOsc} />
      <ellipse cx="32" cy="34" rx="16" ry="22" fill={C.naranja} />
      <path d="M24 15 Q20 34 24 54 M40 15 Q44 34 40 54" stroke={C.naranjaOsc} strokeWidth="1.4" fill="none" opacity="0.7" />
      <path d="M12 22 Q9 30 11 38" stroke={C.naranjaClaro} strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.6" />
      {cara && (
        <g className={brillo ? "hw-parpadeo" : ""} fill={C.luz}>
          <path d="M18 29 L25 22 L28 31 Z" />
          <path d="M46 29 L39 22 L36 31 Z" />
          <path d="M30 35 L32 31 L34 35 Z" />
          <path d="M15 39 Q32 52 49 39 L45 41 L43 44 L39 42 L36 46 L32 43 L28 46 L25 42 L21 44 L19 41 Z" />
        </g>
      )}
    </svg>
  );
}

export function Fantasma({ className = "" }) {
  return (
    <svg viewBox="0 0 60 72" className={className}>
      <path d="M30 3 C13 3 6 17 6 33 L6 64 Q11 57 16 64 Q21 71 26 64 Q31 57 36 64 Q41 71 46 64 Q51 57 54 64 L54 33 C54 17 47 3 30 3 Z"
        fill="#ffffff" fillOpacity="0.93" stroke="#e9d5ff" strokeWidth="1.2" />
      <ellipse cx="22" cy="31" rx="3.6" ry="5" fill={C.sombra} />
      <ellipse cx="38" cy="31" rx="3.6" ry="5" fill={C.sombra} />
      <circle cx="23" cy="29" r="1.1" fill="#fff" />
      <circle cx="39" cy="29" r="1.1" fill="#fff" />
      <ellipse cx="30" cy="43" rx="4" ry="5" fill={C.sombra} />
      <ellipse cx="16" cy="39" rx="3.5" ry="2" fill="#f9a8d4" opacity="0.7" />
      <ellipse cx="44" cy="39" rx="3.5" ry="2" fill="#f9a8d4" opacity="0.7" />
    </svg>
  );
}

const ALA = "M29 15 C22 6 12 5 1 11 C6 12 8 15 8 19 C11 16 15 16 17 20 C19 16 23 16 27 21 Z";

export function Murcielago({ className = "", color = C.sombra }) {
  return (
    <svg viewBox="0 0 64 34" className={className}>
      <g fill={color}>
        <g className="hw-ala hw-ala-izq"><path d={ALA} /></g>
        <g transform="translate(64 0) scale(-1 1)"><g className="hw-ala hw-ala-izq"><path d={ALA} /></g></g>
        <ellipse cx="32" cy="19" rx="5" ry="8" />
        <circle cx="32" cy="10" r="4.6" />
        <path d="M28.6 8 L28 2 L31 6 Z M35.4 8 L36 2 L33 6 Z" />
      </g>
      <circle cx="30.4" cy="10" r="0.9" fill={C.naranja} />
      <circle cx="33.6" cy="10" r="0.9" fill={C.naranja} />
    </svg>
  );
}

// Patas del lado izquierdo (cadera, rodilla, punta) y su fase al caminar;
// el lado derecho es espejo con la fase invertida.
const PATAS = [
  ["M16 15 L8 8 L3 12", 0], ["M15 18 L6 15 L1 20", 1], ["M15 21 L6 23 L2 29", 0], ["M16 24 L9 29 L7 36", 1],
];

export function Arana({ className = "", caminando = false }) {
  const pata = (d, fase) => (
    <path key={d} d={d} className={caminando ? (fase ? "hw-pata hw-pata-a" : "hw-pata hw-pata-b") : ""}
      stroke={C.sombra} strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  );
  return (
    <svg viewBox="0 0 40 40" className={className}>
      <g>{PATAS.map(([d, f]) => pata(d, f))}</g>
      {/* el espejo va en el <g>: un transform de CSS pisaría el atributo */}
      <g transform="translate(40 0) scale(-1 1)">{PATAS.map(([d, f]) => pata(d, f ? 0 : 1))}</g>
      <ellipse cx="20" cy="27" rx="8.5" ry="10" fill={C.sombra} />
      <path d="M17 24 L20 21 L23 24 L20 27 Z M17 30 L20 27 L23 30 L20 33 Z" fill={C.morado} opacity="0.55" />
      <circle cx="20" cy="14" r="6" fill={C.sombra} />
      <circle cx="17.6" cy="13" r="2" fill="#fff" />
      <circle cx="22.4" cy="13" r="2" fill="#fff" />
      <circle cx="17.9" cy="13.4" r="1" fill="#dc2626" />
      <circle cx="22.1" cy="13.4" r="1" fill="#dc2626" />
    </svg>
  );
}

function telaranaPath() {
  const radios = [0, 13, 26, 39, 52, 65, 78, 90].map((g) => (g * Math.PI) / 180);
  const pt = (a, r) => [Math.cos(a) * r, Math.sin(a) * r];
  let d = radios.map((a) => { const [x, y] = pt(a, 100); return `M0 0 L${x.toFixed(1)} ${y.toFixed(1)}`; }).join(" ");
  [16, 30, 45, 60, 76, 92].forEach((r) => {
    radios.forEach((a, i) => {
      if (i === 0) return;
      const [x1, y1] = pt(radios[i - 1], r);
      const [x2, y2] = pt(a, r);
      const [cx, cy] = pt((radios[i - 1] + a) / 2, r * 0.84);
      d += ` M${x1.toFixed(1)} ${y1.toFixed(1)} Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
    });
  });
  return d;
}
const TELARANA_D = telaranaPath();

export function Telarana({ className = "", color = "#78716c" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none">
      <path d={TELARANA_D} stroke={color} strokeWidth="0.7" strokeOpacity="0.7" />
      {/* gotas de rocío */}
      <g fill="#e0f2fe" opacity="0.9">
        <circle cx="38" cy="22" r="1" /><circle cx="20" cy="52" r="0.9" /><circle cx="62" cy="40" r="1.1" />
      </g>
    </svg>
  );
}

function Luna({ className = "" }) {
  return (
    <svg viewBox="0 0 100 100" className={className}>
      <circle cx="50" cy="50" r="46" fill={C.luna} opacity="0.18" />
      <circle cx="50" cy="50" r="36" fill={C.luna} />
      <circle cx="38" cy="40" r="7" fill="#fde68a" />
      <circle cx="60" cy="58" r="9" fill="#fde68a" />
      <circle cx="62" cy="34" r="4" fill="#fde68a" />
    </svg>
  );
}

// Cementerio a lo ancho (se recorta por los lados en pantallas angostas).
function Cementerio({ className = "", suelo = C.sombra, piedra = C.noche2 }) {
  const lapida = (x, h, w = 26, cruz = false) => (
    <g key={x}>
      <path d={`M${x} 90 L${x} ${90 - h + w / 2} A${w / 2} ${w / 2} 0 0 1 ${x + w} ${90 - h + w / 2} L${x + w} 90 Z`} fill={piedra} />
      {cruz
        ? <path d={`M${x + w / 2 - 1.5} ${90 - h + 6} h3 v6 h5 v3 h-5 v10 h-3 v-10 h-5 v-3 h5 Z`} fill={suelo} />
        : <text x={x + w / 2} y={90 - h + w / 2 + 6} textAnchor="middle" fontSize="8" fontWeight="800" fill={suelo} fontFamily="Hanken Grotesk, sans-serif">RIP</text>}
    </g>
  );
  const reja = [];
  for (let x = 520; x <= 700; x += 12) reja.push(<path key={x} d={`M${x} 90 V58 L${x + 2.5} 52 L${x + 5} 58 V90 Z`} fill={suelo} />);
  return (
    <svg viewBox="0 0 1200 90" preserveAspectRatio="xMidYMax slice" className={className}>
      <path d="M0 70 Q150 50 300 66 T600 62 T900 68 T1200 60 V90 H0 Z" fill={suelo} />
      {/* árbol seco */}
      <path d="M90 90 L96 40 Q80 30 70 18 M96 48 Q110 30 128 26 M94 34 Q92 20 100 8 M113 35 Q120 22 118 12" stroke={suelo} strokeWidth="5" fill="none" strokeLinecap="round" />
      <path d="M86 90 L94 44 L100 44 L104 90 Z" fill={suelo} />
      {lapida(200, 44)}{lapida(240, 32, 22, true)}{lapida(380, 50, 30)}
      <rect x="515" y="62" width="190" height="4" fill={suelo} />
      {reja}
      {lapida(820, 40, 24, true)}{lapida(860, 52, 30)}{lapida(1040, 36)}
      {/* casa embrujada */}
      <g fill={suelo}>
        <path d="M950 90 V44 L975 22 L1000 44 V90 Z" />
        <path d="M985 36 V20 H993 V40 Z" />
      </g>
      <g className="hw-parpadeo" fill={C.luz}>
        <rect x="962" y="50" width="8" height="10" rx="1" />
        <rect x="981" y="50" width="8" height="10" rx="1" />
        <rect x="971" y="68" width="9" height="22" rx="4" opacity="0.8" />
      </g>
    </svg>
  );
}

/* ------------------------------------------------------------------ */
/* Guirnalda bajo la barra superior                                    */
/* ------------------------------------------------------------------ */

const FOCOS = [C.naranja, C.morado, C.limo];

function TramoGuirnalda({ i }) {
  const conCalabaza = i % 4 === 2;
  const conMurcielago = i % 9 === 6;
  return (
    <div className="relative shrink-0 w-[56px] h-full">
      <svg viewBox="0 0 56 14" className="absolute inset-x-0 top-0 w-full h-[14px]" preserveAspectRatio="none">
        <path d="M0 1 Q28 12 56 1" stroke="#1c1917" strokeWidth="1.3" fill="none" />
      </svg>
      {conCalabaza ? (
        <div className="hw-colgante absolute left-1/2 -ml-2.5 top-[6px] flex flex-col items-center" style={{ animationDelay: `${-i * 0.37}s` }}>
          <span className="block w-px h-2 bg-stone-800" />
          <Calabaza className="w-5 h-5 hw-brillo-calabaza" />
        </div>
      ) : conMurcielago ? (
        <div className="absolute left-1/2 -ml-3.5 top-[7px]">
          <Murcielago className="w-7 h-4" />
        </div>
      ) : (
        <span className="hw-foco absolute left-1/2 -ml-[5px] top-[8px] block w-2.5 h-3.5 rounded-b-full rounded-t-sm"
          style={{ background: FOCOS[i % 3], color: FOCOS[i % 3], animationDelay: `${(i * 0.53) % 2.4}s` }} />
      )}
    </div>
  );
}

export default function HalloweenDecor() {
  if (!esTemporadaHalloween()) return null;
  return (
    <div aria-hidden="true" data-testid="halloween-decor"
      className="pointer-events-none select-none absolute left-0 right-0 top-full h-[34px] overflow-hidden flex">
      {Array.from({ length: 48 }).map((_, i) => <TramoGuirnalda key={i} i={i} />)}
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Capa para toda la web                                               */
/* ------------------------------------------------------------------ */

// Arañas que bajan y suben de su hilo: [posición, largo, retraso, solo pantallas grandes]
const ARANAS = [
  ["left-[3%]", 90, "0s", false],
  ["left-[17%]", 150, "-2.2s", true],
  ["left-[34%]", 70, "-4.1s", true],
  ["left-[58%]", 120, "-1.3s", true],
  ["left-[78%]", 60, "-3.3s", false],
  ["left-[92%]", 130, "-5s", true],
];

export function HalloweenOverlay() {
  if (!esTemporadaHalloween()) return null;

  return (
    <div aria-hidden="true" data-testid="halloween-overlay"
      className="pointer-events-none select-none fixed inset-0 z-[25] overflow-hidden">
      {/* Telarañas en las esquinas de arriba */}
      <Telarana className="absolute left-0 top-[66px] w-20 sm:w-44" />
      <Telarana className="absolute right-0 top-[66px] w-20 sm:w-44 -scale-x-100" />

      {/* Arañas colgando que suben y bajan */}
      {ARANAS.map(([pos, largo, delay, soloGrande], i) => (
        <div key={i} className={`absolute top-[66px] ${pos} ${soloGrande ? "hidden sm:block" : ""}`}>
          <div className="hw-yoyo flex flex-col items-center -mt-[80px]" style={{ animationDelay: delay, animationDuration: `${6 + (i % 3)}s` }}>
            <span className="block w-px bg-stone-500/70" style={{ height: largo + 80 }} />
            <Arana className="w-7 h-7 sm:w-9 sm:h-9 -mt-1" />
          </div>
        </div>
      ))}

      {/* Araña que de repente cruza caminando toda la pantalla */}
      <AranaCaminante />

    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Araña caminante con ojotes                                          */
/* ------------------------------------------------------------------ */

// Pedido del dueño: "que tenga unos ojitos y se quede viendo a uno". Cada
// 15-25 s entra por un lado, camina hasta la mitad de la pantalla, se voltea
// hacia quien la ve, parpadea y lo sigue con la mirada (el mouse en
// computadora, el último toque en el celular), y luego se va por el otro
// lado. Se mueve con requestAnimationFrame escribiendo el transform directo
// (sin re-render de React), así que no pesa.
const MIRA_MS = 4800;
const VELOCIDAD = 170; // px por segundo

function AranaCaminante() {
  const caja = useRef(null);
  const pupilas = useRef(null);

  useEffect(() => {
    const el = caja.current;
    if (!el || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    let apuntador = null;
    const alMover = (e) => { apuntador = { x: e.clientX, y: e.clientY }; };
    window.addEventListener("pointermove", alMover, { passive: true });
    window.addEventListener("pointerdown", alMover, { passive: true });

    let tramos = [];
    let inicio = 0;
    let rot = 90;
    let raf = 0;
    const distancia = (a, b) => Math.hypot(b.x - a.x, b.y - a.y);
    const planear = (ahora, espera) => {
      const W = window.innerWidth, H = window.innerHeight;
      const izq = Math.random() < 0.5;
      const a = { x: izq ? -90 : W + 90, y: H * (0.3 + Math.random() * 0.45) };
      const m = { x: W * (0.3 + Math.random() * 0.4), y: H * (0.3 + Math.random() * 0.4) };
      const b = { x: izq ? W + 90 : -90, y: H * (0.25 + Math.random() * 0.5) };
      tramos = [
        { tipo: "espera", ms: espera },
        { tipo: "camina", a, b: m, ms: (distancia(a, m) / VELOCIDAD) * 1000 },
        { tipo: "mira", a: m, ms: MIRA_MS },
        { tipo: "camina", a: m, b, ms: (distancia(m, b) / VELOCIDAD) * 1000 },
      ];
      inicio = ahora;
    };
    planear(performance.now(), 4000);

    const cuadro = (ahora) => {
      let t = ahora - inicio;
      let i = 0;
      while (i < tramos.length && t > tramos[i].ms) { t -= tramos[i].ms; i += 1; }
      if (i >= tramos.length) { planear(ahora, 15000 + Math.random() * 10000); raf = requestAnimationFrame(cuadro); return; }
      const tr = tramos[i];
      let x = -200, y = -200, objetivo = rot, dx = 0, dy = -1.6;
      if (tr.tipo === "camina") {
        const k = t / tr.ms;
        x = tr.a.x + (tr.b.x - tr.a.x) * k;
        y = tr.a.y + (tr.b.y - tr.a.y) * k + Math.sin(k * 40) * 2;
        objetivo = (Math.atan2(tr.b.y - tr.a.y, tr.b.x - tr.a.x) * 180) / Math.PI + 90; // la cabeza mira "arriba"
      } else if (tr.tipo === "mira") {
        x = tr.a.x; y = tr.a.y;
        objetivo = 0; // derechita, viendo de frente
        const r = el.getBoundingClientRect();
        const cx = r.left + r.width / 2, cy = r.top + r.height * 0.32;
        if (apuntador) {
          const vx = apuntador.x - cx, vy = apuntador.y - cy, n = Math.hypot(vx, vy) || 1;
          dx = (vx / n) * 1.7; dy = (vy / n) * 1.7;
        } else { dx = 0; dy = 0.6; }
      }
      // giro suave por el camino más corto
      let d = ((objetivo - rot + 540) % 360) - 180;
      rot += d * 0.14;
      el.style.opacity = tr.tipo === "espera" ? "0" : "1";
      el.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%) rotate(${rot}deg)`;
      el.classList.toggle("hw-quieta", tr.tipo !== "camina");
      el.classList.toggle("hw-mirando", tr.tipo === "mira");
      if (pupilas.current) pupilas.current.setAttribute("transform", `translate(${dx.toFixed(2)} ${dy.toFixed(2)})`);
      raf = requestAnimationFrame(cuadro);
    };
    raf = requestAnimationFrame(cuadro);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", alMover);
      window.removeEventListener("pointerdown", alMover);
    };
  }, []);

  const pata = (d, fase) => (
    <path key={d} d={d} className={`hw-pata ${fase ? "hw-pata-a" : "hw-pata-b"}`}
      stroke={C.sombra} strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  );
  return (
    <div ref={caja} className="hw-arana-ojona absolute left-0 top-0 opacity-0 will-change-transform">
      <svg viewBox="0 0 40 40" className="w-16 h-16 sm:w-20 sm:h-20 overflow-visible">
        <g>{PATAS.map(([d, f]) => pata(d, f))}</g>
        <g transform="translate(40 0) scale(-1 1)">{PATAS.map(([d, f]) => pata(d, f ? 0 : 1))}</g>
        <ellipse cx="20" cy="27" rx="8.5" ry="10" fill={C.sombra} />
        <path d="M17 24 L20 21 L23 24 L20 27 Z M17 30 L20 27 L23 30 L20 33 Z" fill={C.morado} opacity="0.55" />
        <circle cx="20" cy="14" r="6.5" fill={C.sombra} />
        {/* ojotes */}
        <circle cx="16.4" cy="12.6" r="4.3" fill="#fff" stroke={C.sombra} strokeWidth="0.8" />
        <circle cx="23.6" cy="12.6" r="4.3" fill="#fff" stroke={C.sombra} strokeWidth="0.8" />
        <g ref={pupilas}>
          <circle cx="16.4" cy="12.6" r="2.3" fill="#0b0612" />
          <circle cx="23.6" cy="12.6" r="2.3" fill="#0b0612" />
          <circle cx="17.2" cy="11.7" r="0.8" fill="#fff" />
          <circle cx="24.4" cy="11.7" r="0.8" fill="#fff" />
        </g>
        {/* párpados (bajan al parpadear) */}
        <g className="hw-parpado" fill={C.sombra}>
          <circle cx="16.4" cy="12.6" r="4.5" />
          <circle cx="23.6" cy="12.6" r="4.5" />
        </g>
        {/* sonrisita y cachetes cuando se queda viendo */}
        <g className="hw-sonrisa">
          <path d="M18 18.2 Q20 19.8 22 18.2" stroke="#fda4af" strokeWidth="0.9" fill="none" strokeLinecap="round" />
          <ellipse cx="13.6" cy="17.4" rx="1.6" ry="0.9" fill="#f9a8d4" opacity="0.8" />
          <ellipse cx="26.4" cy="17.4" rx="1.6" ry="0.9" fill="#f9a8d4" opacity="0.8" />
        </g>
      </svg>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Calabazas al final de cada página                                   */
/* ------------------------------------------------------------------ */

// Antes era una franja de noche con cementerio; el dueño la cambió por solo
// calabazas en las esquinas (2026-10-06). Va al FINAL de la página, no fija:
// fija tapaba los precios y chocaría con los botones flotantes de la tienda.
export function HalloweenCementerio() {
  if (!esTemporadaHalloween()) return null;
  return (
    <div aria-hidden="true" data-testid="halloween-calabazas"
      className="pointer-events-none select-none flex items-end justify-between px-3 sm:px-8 pb-2">
      <div className="flex items-end gap-1">
        <Calabaza className="w-12 h-11 sm:w-14 sm:h-12 hw-brillo-calabaza" />
        <Calabaza className="w-8 h-7 sm:w-9 sm:h-8 hw-brillo-calabaza" />
      </div>
      <div className="flex items-end gap-1">
        <Calabaza className="w-8 h-7 sm:w-9 sm:h-8 hw-brillo-calabaza" />
        <Calabaza className="w-12 h-11 sm:w-14 sm:h-12 hw-brillo-calabaza" />
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Banner de temporada (portada y tienda)                              */
/* ------------------------------------------------------------------ */

export function HalloweenBanner({ className = "" }) {
  if (!esTemporadaHalloween()) return null;
  return (
    <div aria-hidden="true" className={`relative overflow-hidden rounded-2xl text-left ${className}`}
      style={{ background: `radial-gradient(120% 140% at 85% 0%, ${C.noche2} 0%, ${C.noche} 60%)` }}>
      <div className="absolute inset-0 hw-estrellas opacity-80" />
      <Luna className="absolute -top-6 right-4 sm:right-10 w-24 sm:w-32 hw-luna" />
      <Murcielago className="absolute top-5 right-[30%] w-8" color="#0b0612" />
      <Murcielago className="absolute top-12 right-[22%] w-5" color="#0b0612" />
      <Telarana className="absolute -left-1 -top-1 w-16 sm:w-20" color="#a8a29e" />
      <Cementerio className="absolute inset-x-0 bottom-0 w-full h-10 sm:h-14 opacity-90" />
      <div className="relative px-5 sm:px-8 py-6 sm:py-7 pr-28 sm:pr-48">
        <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em]" style={{ color: C.naranjaClaro }}>Temporada de Halloween</p>
        <p className="font-head text-2xl sm:text-4xl font-extrabold text-white mt-1 leading-tight">
          ¡Feliz <span style={{ color: C.naranja }}>Halloween</span>!
        </p>
        <p className="text-sm sm:text-base text-violet-200/90 mt-1.5 mb-8 sm:mb-10 max-w-md">
          Noches de terror, maratones y sustos con tus cuentas favoritas.
        </p>
      </div>
      <div className="absolute right-3 sm:right-8 bottom-1 sm:bottom-2 flex items-end gap-1">
        <Calabaza className="w-10 h-9 sm:w-14 sm:h-12 hw-brillo-calabaza" />
        <Calabaza className="w-14 h-12 sm:w-20 sm:h-[4.5rem] hw-brillo-calabaza" />
      </div>
    </div>
  );
}

// Telarañita para la esquina de cada tarjeta de producto.
export function HalloweenCardWeb() {
  if (!esTemporadaHalloween()) return null;
  return (
    <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-0 w-12 sm:w-16 -scale-y-100 opacity-80">
      <Telarana color="#f5f5f4" />
    </div>
  );
}
